import { render, staticRenderFns } from "./runes_dragable.vue?vue&type=template&id=4c2e937c&scoped=true&"
import script from "./runes_dragable.vue?vue&type=script&lang=js&"
export * from "./runes_dragable.vue?vue&type=script&lang=js&"
import style0 from "./runes_dragable.vue?vue&type=style&index=0&id=4c2e937c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2e937c",
  null
  
)

export default component.exports